import { constant, Decoder, number, object, string, union } from '@mojotech/json-type-validation'

import { programLanguageTypeDecoder } from '../language/programLanguageTypeDecoder'

import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { convertJudgeStatusType } from '@/domain/value_objects/judge/JudgeStatusType'

export const judgeRecordDecoder: Decoder<JudgeRecord> = object({
  accuracy: string(),
  codeSize: number(),
  cpuTime: number(),
  judgeDate: number().map(x => new Date(x)),
  judgeId: number(),
  judgeType: number(),
  language: union(programLanguageTypeDecoder, string()),
  memory: number(),
  problemId: string(),
  problemTitle: union(string(), constant(null)),
  score: union(number(), constant(null)),
  status: number().map(x => convertJudgeStatusType(x)),
  submissionDate: number().map(x => new Date(x)),
  token: union(string(), constant(null)),
  userId: string()
}).map(x => ({ ...x, programLanguage: x.language }))
